import { Col, Container, Row } from 'react-bootstrap'
import { GOTO_HELP_ARTICLE_URL } from '../../../../../common/integrations'

export const GoToSettings = () => {
  return (
    <Container className='p-0'>
      <Row className='mb-4'>
        <Col>
          <h3>Call processing method</h3>
          <p className='text-muted'>Manage how Zocks processes your GoTo Connect phone calls.</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className='fw-bold mb-1'>Process GoTo Connect recordings</div>
          <p className='text-muted mb-2'>Zocks processes calls only when a GoTo Connect recording is available.</p>
          <p className='text-muted mb-2'>
            <span className='fw-bold'>Action required in GoTo Connect:</span> enable call recording for the relevant inbound and outbound calls, and make sure
            recording API access is enabled in GoTo Admin. Without this GoTo-side setup, connected users may not see calls processed in Zocks.
          </p>
          <p className='text-muted mb-2'>
            After a recorded call ends, Zocks retrieves the recording from GoTo Connect and uses it to generate meeting notes, summaries, transcripts, tasks,
            and CRM updates.
          </p>
          <p className='text-muted mb-2'>If a call is not recorded in GoTo Connect, Zocks will not process the call.</p>
          <p className='text-muted mb-0'>
            Need help? See the{' '}
            <a href={GOTO_HELP_ARTICLE_URL} target='_blank' rel='noreferrer'>
              GoTo Connect setup guide
            </a>
            .
          </p>
        </Col>
      </Row>
    </Container>
  )
}
